import { createContext } from 'react'

export interface SurfaceContext {
  surfaceId: number
  setSurfaceId(number): void
}

export const SurfaceContext = createContext<SurfaceContext>({
  surfaceId: 1,
  setSurfaceId: () => {},
})

SurfaceContext.displayName = 'SurfaceContext'
